// src/features/executive/insight/InsightTab.tsx
import { useTranslation } from 'react-i18next'
import SectionHeader from 'features/executive/components/SectionHeader/SectionHeader'
import GenderDonut from './widgets/GenderDonut'
import AgeGroupBar from './widgets/AgeGroupBar'
import NationalityDonut from './widgets/NationalityDonut'
import PatientCountryDonut from './widgets/PatientCountryDonut'
import OccupationBar from './widgets/OccupationBar'
import SourceChannelDonut from './widgets/SourceChannelDonut'
import RevenueByChannelBar from './widgets/RevenueByChannelBar'
import PromotionBar from './widgets/PromotionBar'
import DecisionFactorsBar from './widgets/DecisionFactorsBar'
import NewPatientTrendCard from './widgets/NewPatientTrendCard'
import NewVsExistingDonut from './widgets/NewVsExistingDonut'
import RetentionRateTile from './widgets/RetentionRateTile'
import AvgVisitsTile from './widgets/AvgVisitsTile'
import { Row2, Row3, Row4, Section, TabRoot, TrendRow } from './usedStyle'

export default function InsightTab() {
  const { t } = useTranslation()
  return (
    <TabRoot>
      {/* Section 1: Demographics — who are the patients? */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.INSIGHT.SECTION.DEMOGRAPHICS')}
          caption={t('EXECUTIVE.INSIGHT.SECTION.DEMOGRAPHICS_CAPTION')}
        />
        <Row4>
          <GenderDonut />
          <AgeGroupBar />
          <NationalityDonut />
          <PatientCountryDonut />
        </Row4>
      </Section>

      {/* Section 2: Patient profile — what defines them? */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.INSIGHT.SECTION.PROFILE')}
          caption={t('EXECUTIVE.INSIGHT.SECTION.PROFILE_CAPTION')}
        />
        <Row2>
          <OccupationBar />
          <DecisionFactorsBar />
        </Row2>
      </Section>

      {/* Section 3: Marketing channels — how did they find us? */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.INSIGHT.SECTION.CHANNELS')}
          caption={t('EXECUTIVE.INSIGHT.SECTION.CHANNELS_CAPTION')}
        />
        <Row3>
          <SourceChannelDonut />
          <RevenueByChannelBar />
          <PromotionBar />
        </Row3>
      </Section>

      {/* Section 4: Acquisition & engagement — do they stick around? */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.INSIGHT.SECTION.ENGAGEMENT')}
          caption={t('EXECUTIVE.INSIGHT.SECTION.ENGAGEMENT_CAPTION')}
        />
        <TrendRow>
          <NewPatientTrendCard />
          <NewVsExistingDonut />
        </TrendRow>
        <Row2>
          <RetentionRateTile />
          <AvgVisitsTile />
        </Row2>
      </Section>
    </TabRoot>
  )
}
